import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OnboardingService } from '../../onboarding/onboarding.service';

@Component({
    selector: 'rosie-process-indicator',
    template: `
  <div class="d-flex align-items-center">
    <div class="step-number">{{step}}/{{steps}}</div>
    <ngb-progressbar class="bar" type="success" [value]="step" [max]="steps" />
  </div>
  `,
    styleUrls: ['process-indicator.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProcessIndicatorComponent implements OnInit {
  @Input() step: number = 1;
  @Input() steps: number = 5;

  constructor(private onboarding: OnboardingService) {
  }

  ngOnInit(): void {
  }
}

